import { useLocation, useNavigate } from "react-router-dom";
import styles from './Packages.module.css'
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Modal from "react-modal";
import DatePicker from '../Time/DatePicker'
import notify from "../Utilities/notify";
import { useDispatch , useSelector} from 'react-redux';
import { getPackageServices } from "../../redux/Slices/Packages/thunk";
import Spinner from 'react-bootstrap/Spinner';


const PackageDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { card } = location.state || {}; // Destructure the card from state
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const PackageServices = useSelector((state) => state.PackagesSlice?.PackageServices);
    const loading = useSelector((state) => state.PackagesSlice?.loading);
    
  console.log("PackageServices",PackageServices)
  console.log("card",card)
  const [termsAndConditions, setTermsAndConditions] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalWidth, setModalWidth] = useState("90%"); // Default width
  const [date, setDate]= useState();
  const dispatch = useDispatch();
  const isArabic = currentLanguage === "ar";
  localStorage.removeItem("reservationPackageData");
  localStorage.removeItem("reservationData");
  localStorage.removeItem("PaymentURL");
  localStorage.removeItem("invoiceId");
    const { settings } = useSelector((state) => state.usersSlice);

  useEffect(() => {

    dispatch(getPackageServices({Id:card?.itm_srl}))

    const handleResize = () => {
      if (window.innerWidth > 1500) {
        setModalWidth("60%"); 
      } 
      else if (window.innerWidth > 1100) {
        setModalWidth("70%"); 
      } else {
        setModalWidth("93%"); 
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const updatedCard = {
    ...card,
    startDate: date, // Set startDate to the current date in ISO format
  };

  const onSubmitToBooking = () => {
    console.log("date", date);
  
    const today = new Date(); // Corrected from "ToDay"
    const limitDays = parseInt(settings?.limit_for_start_package?.trim() || "0", 10);
  
    // Create limit date based on settings
    const limitDate = new Date(today);
    limitDate.setDate(limitDate.getDate() + limitDays);
  
    const selectedDate = new Date(date);
  
    // Remove time from both dates to ensure date-only comparison
    const cleanLimitDate = new Date(limitDate.toISOString().split("T")[0]);
    const cleanSelectedDate = new Date(selectedDate.toISOString().split("T")[0]);
    let formattedToDay = today.toISOString().split("T")[0];

    console.log("ToDay without time:", formattedToDay);
     if(date < formattedToDay) return notify(t('date_must_start_from_today'),"error")

    if (cleanSelectedDate > cleanLimitDate) {
      return notify(
        t('date_must_End_from_LimitedTime', { cleanSelectedDate: cleanLimitDate.toISOString().split("T")[0] }),
        "error"
      );
      
        }
  
    navigate("/checkoutPackage", { state: { card: updatedCard } });
    setIsModalOpen(false);
  };
  
  const onSubmit = ()=>{
    if(termsAndConditions){
      setIsModalOpen(true);
    }
    else notify(t("terms_conditions_agreement"),"error")
  }


  return (
    
    <div className='flex-grow-1'>
     <div className={styles.loginContainer}>
    <div className={styles.loginHeader}>{card?.itm_nam}</div>
    <div>
     {( card?.itm_descr1 != null) &&  <div className={styles.DetailsComponant}>
        <div className={styles.detailsContent}>
       {(card?.itm_descr1 != null)  && <h1>{t('Description')}</h1>}
          <h2>{isArabic ? card?.itm_descr1?.trim() :  card?.itm_descr2?.trim() }</h2>
              <div className={styles.priceContainer}>
            <span >{t('price')}</span>
            <span>{card?.prcandtax?.toFixed(2)} { t('rs')}</span>
          </div>
          <div className={styles.priceContainer}>
           <span >{t('duration')}</span>
           <span>{card.itm_dscnt} { t('day2')}</span>
         </div>
        </div>
      
      </div>}
          
  {  loading ?
  <div style={{width:"50%", margin:"auto", display:"flex", justifyContent:"center", alignItems:"center"}}> <Spinner size={'100'} /> </div>:  <div className={styles.DetailsComponant} style={{border:"none"}}>
        <div className={styles.detailsContent}>
      
        <h1>{t('services')}</h1>
        {PackageServices?.map((el,index) => (
  <div key={index} className={styles.packagesServicesStyle} >
   <div>
                      {isArabic ? el?.itm_nam2 : el?.itm_enm2}
                      </div>
                      <div style={{
                        background:"#fff",
                        color:"#B49345",
                        borderRadius:"4px",
                        minWidth:"30px",
                        display:"flex",
                        justifyContent:"center",
                        fontSize:"18px",
                        fontWeight:"700",
                        height:"35px",
                        alignItems:"center"
                      }}>{el?.itd_totqty}</div>
                    </div>))}   
  { ( card?.itm_descr1 == null)  && 
  <div style={{width:"100%"}}>
           <div className={styles.priceContainer}>
           <span >{t('price')}</span>
           <span>{card?.prcandtax?.toFixed(2)} { t('rs')}</span>
         </div>
           <div className={styles.priceContainer}>
           <span >{t('duration')}</span>
           <span>{card.itm_dscnt} { t('day2')}</span>
         </div>
         </div>
           }
        </div>
      
      </div>}
 


      <div style={{display:"flex", justifyContent:"center", alignItems:"center", gap:"1px", marginTop:"10px"}}>
      <input
          type="checkbox"
          checked={termsAndConditions}
          onChange={(e)=>setTermsAndConditions(e.target.checked)}
          style={{width:"20px", height:"20px", margin:"0 3px"}}
        />
        <span style={{fontSize:"18px", fontWeight:"700"}}>{t('Agreeto')}</span>
        <span> </span>
        <span 
  style={{
    color: "#0066BA", 
    textDecoration: "underline", 
    cursor: "pointer", 
    fontSize: "18px", 
    fontWeight: "700"
  }} 
  onClick={() => navigate('/terms', { state: { termsFromPackage: true } })}
>
  {t('termsAndConditions')}
</span>

      </div>
          <div className={styles.onSubmit} onClick={onSubmit} >{t('subscription')}</div>
  </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Date Picker Modal"
        ariaHideApp={false}
        style={{
          content: {
            width: modalWidth, // Adjust the width
            height: "340px", // Adjust the height
            margin: "auto", // Center the modal
            padding: "20px", // Padding inside the modal
            borderRadius: "10px", // Optional: rounded corners
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between", // Make sure content is spaced
            inset:0,
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
          }
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom:"20px" }}>{t('start_time_selection')}</h2>
        <DatePicker setDate={setDate} />
        <div className={styles.onSubmit} onClick={onSubmitToBooking} >{t('select')}</div>

      </Modal>
    </div>
  );
};

export default PackageDetails;
